class ProductBenefitsComponent extends HTMLElement {
  connectedCallback() {
    this.initDesktopAccordion();
    this.initMobileCarousel();
  }

  /* ---------- 桌面端：手风琴列表 + 右侧媒体联动 ---------- */
  initDesktopAccordion() {
    this.desktopItems = Array.from(this.querySelectorAll('[data-benefits-item]'));
    this.desktopMediaItems = Array.from(this.querySelectorAll('[data-benefits-media-item]'));

    this.desktopItems.forEach((item) => {
      const details = item.querySelector('details');
      if (!details) return;

      details.addEventListener('toggle', () => {
        this.setDesktopActive(this.getDesktopActiveIndex());
      });
    });

    this.setDesktopActive(this.getDesktopActiveIndex());
  }

  getDesktopActiveIndex() {
    const openItem = this.desktopItems.find((item) => item.querySelector('details')?.open);
    return openItem ? Number(openItem.dataset.index) : 'default';
  }

  setDesktopActive(index) {
    this.desktopMediaItems.forEach((media) => {
      const isActive = String(media.dataset.index) === String(index);
      media.classList.toggle('is-active', isActive);
      media.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  /* ---------- 移动端：默认大图 + 标签，点击后切换为沉浸卡片轮播 ---------- */
  initMobileCarousel() {
    this.tagButtons = Array.from(this.querySelectorAll('[data-benefits-tag]'));
    this.mobileDefault = this.querySelector('[data-benefits-mobile-default]');
    this.mobileCarousel = this.querySelector('[data-benefits-mobile-carousel]');
    this.mobileTrack = this.querySelector('[data-benefits-mobile-track]');
    this.mobileSlides = Array.from(this.querySelectorAll('[data-benefits-mobile-slide]'));
    this.mobileCaptions = Array.from(this.querySelectorAll('[data-benefits-mobile-caption]'));
    this.collapseButtons = Array.from(this.querySelectorAll('[data-benefits-collapse]'));
    this.prevButton = this.querySelector('[data-benefits-prev]');
    this.nextButton = this.querySelector('[data-benefits-next]');

    if (!this.mobileTrack || this.mobileSlides.length === 0) return;

    this.tagButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.enterMobileCarousel(Number(button.dataset.index));
      });
    });

    this.collapseButtons.forEach((button) => {
      button.addEventListener('click', () => this.exitMobileCarousel());
    });

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.stepMobile(-1));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.stepMobile(1));
    }

    let scrollTimer;
    this.mobileTrack.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        this.syncMobileState(this.getMobileActiveIndex());
      }, 100);
    });
  }

  enterMobileCarousel(index) {
    if (this.mobileDefault) this.mobileDefault.classList.add('is-hidden');
    if (this.mobileCarousel) this.mobileCarousel.classList.add('is-active');
    this.scrollMobileTo(index, 'auto');
    this.syncMobileState(index);
  }

  exitMobileCarousel() {
    if (this.mobileDefault) this.mobileDefault.classList.remove('is-hidden');
    if (this.mobileCarousel) this.mobileCarousel.classList.remove('is-active');
  }

  syncMobileState(index) {
    this.mobileCaptions.forEach((caption) => {
      caption.classList.toggle('is-active', Number(caption.dataset.index) === index);
    });
    if (this.prevButton) this.prevButton.disabled = index <= 0;
    if (this.nextButton) this.nextButton.disabled = index >= this.mobileSlides.length - 1;
  }

  getMobileActiveIndex() {
    if (!this.mobileTrack) return 0;
    const trackLeft = this.mobileTrack.scrollLeft;
    const slideWidth = this.mobileTrack.clientWidth || 1;
    return Math.round(trackLeft / slideWidth);
  }

  scrollMobileTo(index, behavior) {
    const target = this.mobileSlides[index];
    if (!target || !this.mobileTrack) return;
    this.mobileTrack.scrollTo({ left: target.offsetLeft, behavior: behavior || 'smooth' });
  }

  stepMobile(direction) {
    const nextIndex = this.getMobileActiveIndex() + direction;
    if (nextIndex < 0 || nextIndex >= this.mobileSlides.length) return;
    this.scrollMobileTo(nextIndex);
    this.syncMobileState(nextIndex);
  }
}

if (!customElements.get('product-benefits-component')) {
  customElements.define('product-benefits-component', ProductBenefitsComponent);
}
